import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticMediumEditor.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticMediumEditor.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-medium-editor/VuesticMediumEditor.vue?vue&type=script&lang=js
// module id = PyNc
// module chunks = 41